import cookies from 'js-cookie'

import { useConfigStore } from '../stores/config'
import { useSourcepointStore } from '../stores/sourcepoint'

export function useAdditionalConsent () {
  const rsConfig = useConfigStore().rsConfig
  const sourcepointStore = useSourcepointStore()

  function readCookie (): Record<string, number> {
    try {
      return JSON.parse(atob(cookies.get(rsConfig?.consent?.embedCookieName)))
    } catch (_) {
      return {}
    }
  }

  // Seed the reactive state from the cookie once at app init (client-only).
  function loadAdditionalConsent (): void {
    sourcepointStore.setAdditionalConsent(readCookie())
  }

  // Reactive source of truth: grant/revoke update this synchronously, so the UI reacts without a
  // Sourcepoint round-trip (essential for PUR, where the CMP/stub may never answer).
  function getAdditionalConsent (): Record<string, number> {
    return sourcepointStore.additionalConsent
  }

  function storeAdditionalConsent (consentObject: Record<string, number> = {}) {
    sourcepointStore.setAdditionalConsent(consentObject)
    cookies.set(
      rsConfig?.consent?.embedCookieName,
      btoa(JSON.stringify(consentObject)),
      {
        expires: 30,
        sameSite: 'strict'
      })
  }

  return { getAdditionalConsent, storeAdditionalConsent, loadAdditionalConsent }
}
